import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: '1.5rem',
  },
  buttonGroup: {
    display: 'flex',
    padding: '1.5rem',
    justifyContent: 'left',
  },
}));

const Alert = ({
  isVisible = false, // visibility is controlled by parent component
  title = '',
  children,
  okLabel = '',
  cancelLabel = '',
  onClickOK = () => {},
  onClickCancel = () => {},
}) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const handleOK = () => {
    onClickOK();
  };

  const handleCancel = () => {
    onClickCancel();
  };

  const defaultOkLabel = t('swal.confirm.yes');

  return (
    <Dialog
      open={isVisible}
      onClose={handleCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-desription"
    >
      <DialogTitle id="alert-dialog-title" className={styles.title}>
        {title}
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">{children}</DialogContentText>
      </DialogContent>

      <DialogActions className={styles.buttonGroup}>
        <Button onClick={handleOK} variant="contained">
          {okLabel.trim() || defaultOkLabel}
        </Button>
        {cancelLabel && (
          <Button onClick={handleCancel} variant="outlined">
            {cancelLabel}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

Alert.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
  okLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onClickOK: PropTypes.func.isRequired,
  onClickCancel: PropTypes.func,
};

export default Alert;
